import { JSX } from "react";
import Time from "../util/Time";
import { Stack, Typography } from "@mui/material";
import { Color, getHexCode } from "../util/Color";

// ロット出荷状況の表示文字列。数値進捗(貼付済/予定)込み。mock EventStatusBuilder と同文言。
export function lotStatusLabel(lot: { material_count: number; shipped_at?: number | null; Materials: unknown[] }): string {
  const attached = lot.Materials.length;
  if (lot.material_count > 0 && attached === lot.material_count) {
    return `出荷済 (${new Time(lot.shipped_at ?? 0).Format("YYYY/MM/dd HH:mm:ss")})`;
  }
  if (attached > lot.material_count) {
    return `出荷個数超過 (${attached}/${lot.material_count})`;
  }
  return `出荷前 (${attached}/${lot.material_count})`;
}

export function LotStatusBuilder(lot: { Materials: { id: number }[]; material_count: number; shipped_at: number | null }, fontSize: number = 18): JSX.Element {
  const shipped = lot.material_count > 0 && lot.Materials.length === lot.material_count;
  let color: Color = "DeepRed";
  if (shipped) {
    color = "ActiveGreen";
  }
  return (
    <Stack justifyContent="center" width="100%" height="100%" flex={1}>
      <Typography color={getHexCode(color)} fontSize={fontSize}>{lotStatusLabel(lot)}</Typography>
    </Stack>
  );
}